import { render, staticRenderFns } from "./help_common_problem.vue?vue&type=template&id=753c06ea&scoped=true&"
import script from "./help_common_problem.vue?vue&type=script&lang=js&"
export * from "./help_common_problem.vue?vue&type=script&lang=js&"
import style0 from "./help_common_problem.vue?vue&type=style&index=0&id=753c06ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753c06ea",
  null
  
)

export default component.exports